import {
    Cell,
    Column,
    Row,
    Sort,
    SortOrder,
} from '../../coaching-observation/experimental.grid';
import { PeriodType } from '../../widget/date-range.widget.model';
import {
    CoverageDataDto,
    RosterType,
} from '../coverage.coaching-insight.model';
import { ScheduleEventDto } from '../schedule.coaching-insight.model';
import {
    EventParticipant,
    EventType,
} from '../schedule/models/schedule-event.model';

import {
    CellContext,
    ColumnContext,
    ColumnType,
    RosterItem,
    RowContext,
} from './coaching-coverage-grid.model';
import { DateRange } from './select-period-date-range.component';

export interface RootState {
    pending: {
        reload?: boolean;
    };

    periodType: PeriodType;
    maxShown: number;
    rosterType: RosterType;
    data?: CoverageDataDto; // TODO revise. don't know yet if all data will be requested up front or if there will be a 'numPeriods' api param
    periodDateRanges?: DateRange[]; // TODO revise. may change to 'periodDateRanges'. this is extracted from 'data'. there may be a separate api call to get dates available for a period type
    selectedDateRange?: DateRange;
    periodCanGoLeft?: boolean;
    periodCanGoRight?: boolean;
    scheduleEvents?: ScheduleEventDto[];
    roster?: RosterItem[];

    gridColumns?: Array<Column<ColumnContext>>; // this is special. it should not be recreated else the entire grid would be invalidated
    gridRows?: Array<Row<RowContext, CellContext>>;
    gridSortDefs?: Sort[];
    gridColumnsNeedResize?: string[]; // columnIds. used for forcing auto sizing
    gridNeedsLayout?: number; // Date.now(). used for forcing a grid layout

    // modals
    createEventContext?: {
        userId?: number;
    };
    selectPeriodRangeContext?: {
        selection?: number;
    };
    scheduleForUserContext?: {
        managerId?: number;
        performerId?: number;
        performerUser?: EventParticipant;
    };
    selectPeriodDateRangeContext?: {
        column?: Column<ColumnContext>;
        elementSelector?: string;
        dateRanges?: DateRange[];
        selection?: DateRange;
    };
    scheduleItemsListContext?: {
        cell?: Cell<CellContext>;
        type?: EventType;
        elementSelector?: string;
        schedule?: ScheduleEventDto[];
    };
}

export const defaultSortDef = (): Sort => ({
    columnId: ColumnType.NAME.toString(),
    order: SortOrder.ASC,
});

export const defaultState = (): RootState => ({
    pending: {},
    periodType: PeriodType.WEEK,
    maxShown: 2,
    rosterType: RosterType.TEAM,
    gridSortDefs: [defaultSortDef()],
});
